import { Drawer, LoadingOverlay } from "@mantine/core";
import React, { FC, SetStateAction, useState } from "react";

import { parseUrl } from "utils/helpers";
import { useWindowSize } from "react-use";

type DocumentWrapperProps = {
  show: boolean;
  setShow: React.Dispatch<SetStateAction<boolean>>;
  url: string;
  title?: string;
  //   children: ReactNode | ReactNode[];
};

const DocumentWrapper: FC<DocumentWrapperProps> = ({ show, setShow, url }) => {
  const [loading, setLoading] = useState(true);
  const { width } = useWindowSize();
  const onLoad = () => {
    setLoading(false);
  };
  console.log("DocumentWrapper URL:", url);
  return (
    <Drawer
      // width={width < 1242 ? width * 0.8 : width * 0.4}
      opened={show}
      closeOnClickOutside={false}
      onClose={() => setShow(false)}
      position="right"
      size={width < 1242 ? width * 0.8 : width * 0.4}
    >
      <LoadingOverlay visible={loading} />
      <div className="">
        <iframe
          src={parseUrl(url, {
            defaultProtocol: "https",
            forceHttps: true,
          })}
          title="preview"
          onLoadStart={() => setLoading(true)}
          onLoad={onLoad}
          width="100%"
          className="min-h-full h-screen p-3"
        // frameBorder={0}
        ></iframe>
      </div>
    </Drawer>
  );
};

export default DocumentWrapper;
